import React from "react";
import Moment from "moment";
import AvatarBoy from "../../../../../media/avatars/011-boy-5.svg";
import AvatarGirl from "../../../../../media/avatars/028-girl-16.svg";

export function CBioStd({ studentData }) {
  return (
    <div className="card card-custom gutter-b">
      <div className="card-body">
        <div className="row">
          <div className="col-12 col-lg-6">
            <h3 className="mb-8">Personal Biodata</h3>
            <div className="row mb-6">
              <label className="col-lg-4 font-weight-bold h6">Fullname</label>
              <div className="col-lg-8">
                <span className="font-weight-bold text-gray-800 h6 text-capitalize">
                  {studentData?.fullname}
                </span>
              </div>
            </div>

            <div className="row mb-6">
              <label className="col-lg-4 font-weight-bold h6">Birthdate</label>
              <div className="col-lg-8">
                <span className="font-weight-bold text-gray-800 h6 text-capitalize">
                  {studentData?.birthplace
                    ? studentData?.birthplace + ", "
                    : ""}
                </span>
                <span className="font-weight-bold text-gray-800 h6 text-capitalize">
                  {studentData?.birthdate
                    ? Moment(studentData?.birthdate).format("DD MMM YYYY")
                    : ""}
                </span>
              </div>
            </div>

            <div className="row mb-6">
              <label className="col-lg-4 font-weight-bold h6">Gender</label>
              <div className="col-lg-8">
                <span className="font-weight-bold text-gray-800 h6 text-capitalize">
                  {studentData?.gender
                    ? studentData?.gender === "P"
                      ? "Male"
                      : "Female"
                    : ""}
                </span>
              </div>
            </div>

            <div className="row mb-6">
              <label className="col-lg-4 font-weight-bold h6">Religion</label>
              <div className="col-lg-8">
                <span className="font-weight-bold text-gray-800 h6 text-capitalize">
                  {studentData?.religion
                    ? studentData?.religion.name
                    : "-"}
                </span>
              </div>
            </div>

            <div className="row mb-6">
              <label className="col-lg-4 font-weight-bold h6">Cellular</label>
              <div className="col-lg-8">
                <span className="font-weight-bold text-gray-800 h6 text-capitalize">
                  {studentData?.cellular ? studentData?.cellular : "-"}
                </span>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <h3 className="mb-8">Contact Person</h3>
            {Object.values(studentData?.reff_address).length > 0 ? (
              studentData?.reff_address.map((v, index) => (
                <div className="p-3 border rounded" key={index}>
                  <p className="mb-0">
                    <i className="fas fa-map-marker-alt mr-2 font-size-lg"></i>
                    <span className="">
                      {v.address} {v.postalcode ? v.postalcode + ", " : ""}{" "}
                      {v.city ? v.city.name + ", " : ""}{" "}
                      {v.country ? v.country.name + ", " : ""}
                    </span>
                  </p>
                  <p className="mb-0">
                    <span className="mr-2">
                      <i className="socicon-whatsapp mr-2 font-size-lg"></i>
                      <span>{v.cellular1}</span>
                    </span>
                    {v.cellular2 ? (
                      <span className="mr-2">
                        <i className="socicon-whatsapp mr-2 font-size-lg"></i>
                        <span>{v.cellular2}</span>
                      </span>
                    ) : (
                      ""
                    )}
                    {v.email ? (
                      <span>
                        <i className="flaticon-multimedia-2 mr-2 font-size-lg"></i>
                        <span className="">{v.email}</span>
                      </span>
                    ) : (
                      ""
                    )}
                  </p>
                </div>
              ))
            ) : (
              <div className="p-3 border rounded">
                <p className="text-center">
                  <i className="flaticon2-open-box font-size-lg"></i>
                  <span>No record found</span>
                </p>
              </div>
            )}

            {studentData?.reff_family &&
            Object.values(studentData?.reff_family).length > 0 ? (
              <div className="fams">
                <h3 className="my-5">Family</h3>
                <div className="d-flex align-items-center">
                  {studentData?.reff_family.map((v, index) => (
                    <div
                      className="d-flex align-items-center border mr-5 p-3 rounded"
                      key={index}
                    >
                      <div className="symbol symbol-40 symbol-light-success flex-shrink-0">
                        {v.gender ? (
                          <img
                            src={v.gender === "p" ? AvatarBoy : AvatarGirl}
                            alt={v.fullname}
                            className="bg-light"
                          />
                        ) : (
                          <span className="symbol-label font-size-h4 font-weight-bold">
                            {v.firstname ? v.firstname.charAt(0) : ""}
                          </span>
                        )}
                      </div>
                      <div className="ml-4">
                        <div className="text-dark-75 font-weight-bolder h6 mb-0">
                          {v.fullname}
                        </div>
                        <span className="text-muted font-weight-bold">
                          {v.type}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
